export const users: TableModule = {
    name: "users",
    route: "spa.settings.organisations.users",
    defaultOrder: {
        column: "lastname|firstname",
        direction: "asc"
    },
    routeParams: [{
        param: "organisation",
        prop: "organisation_id"
    }],
    columns: [
        {
            name: "customName",
            sortable: true,
            pageLink: true,
            sortBy: "lastname|firstname",
            mobile: true,
            width: "w-1/2 sm:w-auto"
        },
        {
            name: "email",
            sortable: true
        },
        {
            name: "role_name",
            sortable: true,
            mobile: true
        },
        {
            name: "created_at",
            sortable: true,
            breakpoint: "md"
        }
    ],
    filters: [
        {
            name: "id",
            column: "users.id",
            type: "numeric",
            reduced: '[,]'
        },
        {
            name: "firstname",
            column: "users.firstname",
            type: "string"
        },
        {
            name: "fullname",
            column: "users.fullname",
            type: "string"
        },
        {
            name: "birthday",
            column: "users.birthday",
            type: "exists"
        },
        {
            name: "email",
            column: "users.email",
            type: "string",
            reduced: 'like'
        },
        {
            name: "role",
            column: "users.role_name",
            type: "select",
            options: [
                {
                    value: "admin",
                    label: "users.roles.admin"
                },
                {
                    value: "user",
                    label: "users.roles.user"
                }
            ],
            reduced: true
        },
        {
            name: "created_at",
            column: "users.created_at",
            type: "date",
        }
    ],
    quickFilters: [
        {
            name: "quickFilterOnlyEmployees",
            column: "users.role_name",
            value: [
                "user"
            ],
            operator: "in"
        }
    ],
    tools: [
        {
            name: "users.delete",
            color: "rose",
            icon: "delete"
        },
        {
            name: "users.create",
            isCreateAction: true,
            ability: [
                "create",
                "users"
            ]
        }
    ]
}